import { regionService } from '@/services/RegionService';
import { websocketService } from '@/services/WebsocketService';

const state = () => ({
  regions: [],
  regionsWorkspaceId: null,
  isLoading: false,
  hasError: false,
});

const mutations = {
  setRegions(state: any, regions: any) {
    state.regions = regions;
    state.hasError = false;
  },
  setRegionsError(state: any, hasError: boolean) {
    state.hasError = hasError;
  },
  setRegionsWorkspaceId(state: any, id: any) {
    state.regionsWorkspaceId = id;
  },
  setLoading(state: any, isLoading: boolean) {
    state.isLoading = isLoading;
  },
};

const actions = {
  updateRegion({ commit, state }: any, region: any = null) {
    if (region && region.id) {
      const index = state.regions.findIndex((item: any) => parseInt(item.id, 10) === parseInt(region.id, 10));
      if (index !== -1) {
        state.regions[index] = {
          ...state.regions[index],
          ...region,
        };
      }
      commit('setRegions', [...state.regions]);
    }
  },
  getRegions({ commit, state, rootState }: any, isForced: boolean = false) {
    commit('setRegionsError', false);
    return new Promise(resolve => {
      if (
        state.regions &&
        state.regions.length > 0 &&
        !isForced &&
        state.regionsWorkspaceId === rootState.currentWorkspace.id &&
        websocketService.isConnected
      ) {
        commit('setRegions', [...state.regions]);
        resolve(state.regions);
      } else if (!state.isLoading) {
        commit('setLoading', true);
        regionService
          .getRegions(rootState.currentWorkspace.id)
          .then((data: any) => {
            commit('setRegionsWorkspaceId', rootState.currentWorkspace.id);
            commit('setRegions', data.regions);
            commit('setLoading', false);
            resolve(data);
          })
          .catch(() => {
            commit('setRegionsWorkspaceId', rootState.currentWorkspace.id);
            commit('setLoading', false);
            commit('setRegions', []);
            commit('setRegionsError', true);
          });
      } else {
        resolve([]);
      }
    });
  },
};

const getters = {
  getRegionById: (state: any, getters: any, rootState: any) => (id: any) => {
    return state.regions.find((item: any) => item && parseInt(id, 10) === parseInt(item.id, 10)) || {};
  },
  getCurrentRegion: (state: any, getters: any, rootState: any) => {
    return (
      state.regions.find(
        (item: any) => item && parseInt(rootState.currentWorkspace.currentRegionId, 10) === parseInt(item.id, 10)
      ) || {}
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
